import { SET_MUSICPLAYER_TRACK, STOP_MUSIC, PAUSE_MUSIC } from '../actions/musicPlayerAction';

const initialState = {
  currentTrack: null,
  isPlaying: false,
};

const musicPlayerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MUSICPLAYER_TRACK:
      return {
        ...state,
        currentTrack: action.payload,
        currentTrackStatus:true,
        isPlaying: true,
      };
    case PAUSE_MUSIC:
      return {
        ...state,
        currentTrackStatus:true,
        isPlaying: false, // Keep the track but stop playing
      };
    case STOP_MUSIC:
      return {
        ...state,
        currentTrack: null, // Reset the track
        currentTrackStatus:false,
        isPlaying: false,
      };
    default:
      return state;
  }
};

export default musicPlayerReducer;


// import { SET_MUSICPLAYER_TRACK, STOP_MUSIC } from '../actions/musicPlayerAction';

// const initialState = {
//   currentTrack: null,
//   isPlaying: false,
// };

// const musicPlayerReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case SET_MUSICPLAYER_TRACK:
//       return {
//         ...state,
//         currentTrack: action.payload,
//         isPlaying: true,
//       };
//     case STOP_MUSIC:
//       return {
//         ...state,
//         currentTrack: null,
//         isPlaying: false,
//       };
//     default:
//       return state;
//   }
// };

// export default musicPlayerReducer;

